import SectionHeader from './SectionHeader';

export default function EducationSection({ data, template, accent }) {
  if (!data.education || data.education.length === 0) return null;

  return (
    <div className="resume-section">
      <SectionHeader template={template} accent={accent}>Education</SectionHeader>
      <div style={{ fontFamily: template.bodyFont, fontSize: '10.5pt', color: '#1c1c1c', lineHeight: 1.5 }}>
        {data.education.map((ed, i) => (
          <div key={i} style={{ marginBottom: i === data.education.length - 1 ? 0 : '0.1in' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '0.3in' }}>
              <div style={{ fontWeight: 600, color: '#111' }}>
                {ed.degree}
                {ed.school && <span style={{ fontWeight: 400 }}>{' — '}{ed.school}</span>}
                {ed.location && <span style={{ fontWeight: 400, color: '#3a3a3a' }}>{', '}{ed.location}</span>}
              </div>
              <div style={{
                fontVariantNumeric: template.tabularDates ? 'tabular-nums' : 'normal',
                color: '#3a3a3a',
                whiteSpace: 'nowrap',
                fontSize: '10pt',
              }}>{ed.date}</div>
            </div>
            {ed.honors && (
              <div style={{ fontStyle: 'italic', color: '#3a3a3a', marginTop: '0.02in' }}>{ed.honors}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
